/* Daryada — charge « Dans le même esprit » après l'affichage de la page. */
(() => {
  const load = async (container) => {
    if (container.dataset.loaded || !container.dataset.url) return;
    container.dataset.loaded = 'true';
    try {
      const response = await fetch(container.dataset.url);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('[data-recommandations]');
      if (fresh && fresh.innerHTML.trim()) {
        container.innerHTML = fresh.innerHTML;
        // Les cartes arrivent visibles : pas de révélation différée ici
        container.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-revealed'));
      }
    } catch (error) {
      // Sans recommandations, la section reste simplement vide
    }
  };

  const init = () => {
    document.querySelectorAll('[data-recommandations]').forEach((container) => {
      if (!('IntersectionObserver' in window)) {
        load(container);
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            load(container);
          }
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      observer.observe(container);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
